import { Component, OnInit, OnDestroy, ChangeDetectorRef, AfterViewChecked } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Store } from '@ngrx/store';

import { Subscription } from 'rxjs/Subscription';
import { Observable } from 'rxjs/Observable';

import { IApplicationState } from '../../../stateManagement/states/applicationState';
import { IAuthenticationDataState } from '../../../stateManagement/states/dataState';
import * as fromRoot from '../../../stateManagement/rootReducer';
import { AuthenticationService } from '../../../authentication/services/authentication.service';
import { ServerLoginSuccessAction, ServerLogoutAction } from '../../../stateManagement/actions/data/authentication';

import { LOCALSTORAGE_AUTH } from '../../../../setup/configurations';

import { ToasterService, ToasterConfig, BodyOutputType } from 'angular2-toaster/angular2-toaster';
import { IToastr, IPortalInfo } from '../../../shared/types';
import { AuthenticatedGuard } from '../../../shared/authenticated.guard';
import { VersionCheckerService } from '../../../shared/services/version-checker.service';
import { IAppVersion } from '../../../stateManagement/states/containersState';
import { IAccount } from '../../../authentication/types';
import { ApplicationUpdateVersionAction, ApplicationCheckVersionAction } from '../../../stateManagement/actions/containers/application';
import { GetStageInfoAction } from '../../../stateManagement/actions/data/stages';
import { timeout } from 'q';

@Component({
  selector: 'tr-application',
  templateUrl: './application.component.html',
  styleUrls: ['./application.component.scss']
})
export class ApplicationComponent implements OnInit, OnDestroy, AfterViewChecked {
  subscriptions: Array<Subscription> = [];
  isBusy$: Observable<boolean>;
  appProgress$: Observable<any>;
  isAuthenticated$: Observable<boolean>;

  toasterconfig: ToasterConfig = new ToasterConfig({
    bodyOutputType: BodyOutputType.TrustedHtml,
    tapToDismiss: true,
    preventDuplicates: true,
    mouseoverTimerStop: false,
    // controlled by assets/client/style/style.css !important
    positionClass: 'toast-top-full-width',
    //positionClass: 'brs-message',
    showCloseButton: true,
    limit: 1, // only 1 message at once
    timeout: 10000 // 10 seconds
  });

  portalInfo$: Observable<IPortalInfo>;
  wasOffline: boolean = false;

  isConnected$: Observable<boolean> = Observable.merge(
      Observable.of(navigator.onLine),
      Observable.fromEvent(window, 'online').map(() => true),
      Observable.fromEvent(window, 'offline').map(() => false));

//  appVersion$: Observable<IAppVersion> = this.store.select(fromRoot.getApplicationVersion);
  multipleOffers$: Observable<IAccount> = this.store.select(fromRoot.getAuthenticationAccount);
    appVersion$:Observable<IAccount> = this.store.select(fromRoot.getAuthenticationAccount);

  defaultStyle: any;
  constructor(
    private cdRef: ChangeDetectorRef,
    private store: Store<IApplicationState>,
    private router: Router,
    private authenticationService: AuthenticationService,
    private toasterService: ToasterService,
    private authenticatedGuard: AuthenticatedGuard,
    private versionCheckerService: VersionCheckerService
  ) {}

  ngOnInit() {

    this.defaultStyle = document.getElementById('portal-theme').getAttribute('href');

    this.checkInitialAuthentication();
    this.subscribeToNotifications();
    this.checkConnection();
    this.getSubtheme();
  }

  ngAfterViewChecked() {
    this.isBusy$ = this.store.select(fromRoot.isApplicationBusy);
    this.appProgress$ = this.store.select(fromRoot.getApplicationProgress);
    this.isAuthenticated$ = this.store.select(fromRoot.getAuthenticationIsAuthenticated);
    this.portalInfo$ = this.store.select(fromRoot.getApplicationPortalInformation);
    // this.appVersion$ = this.store.select(fromRoot.getApplicationVersion);
    this.cdRef.detectChanges();
  }

  checkInitialAuthentication(): void {
    const obj = this.authenticationService.checkInitialAuthentication();
    if (obj) {
      // evil fix for bug in @ngrx/dev-tools
      // https://github.com/ngrx/store-devtools/issues/25
      // setTimeout(() => {
      this.store.dispatch(new ServerLoginSuccessAction(obj));
      // });
    }

  }

  checkConnection(): void {
    this.subscriptions.push(
      this.isConnected$.subscribe ( (isOnline: boolean) => {
        if (!isOnline) {
          const offlineToastr = {
            type: 'error',
            title: 'You are in offline mode',
            body: `No internet connection is available.
            <p>Any changes you make will not be saved, please check your internet connection before proceeding.</p>`,
            toastId: 'offline-message',
            toastContainerId: 99,
            bodyOutputType: BodyOutputType.TrustedHtml,
            onShowCallback: (toastr) => {
              if (toastr['timeoutId']) {
                clearTimeout(toastr.timeoutId);
                this.wasOffline = true;
              }
            },
            clickHandler: (toast, isCloseButton) => {
              return false;
            }
          };
          this.toasterService.pop(offlineToastr);
        } else {
          if (this.wasOffline) {
            this.toasterService.clear();
            this.wasOffline = false;
          }
        }
      })
    );
  }

  getSubtheme() {
    this.subscriptions.push(
      this.store.select(fromRoot.getAuthenticationSubPortalName).subscribe((subPortalName: string) => {
        //console.log(subPortalName);
        if (subPortalName !== '') {
          document.getElementById('portal-theme').setAttribute('href', `clients/${subPortalName}/styles/styles.css`);
        } else {
          if (this.defaultStyle) {
            document.getElementById('portal-theme').setAttribute('href', this.defaultStyle);
          }
        }
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  logout(): void {
    localStorage.removeItem(LOCALSTORAGE_AUTH);
    this.store.dispatch(new ServerLogoutAction({}));
    location.reload();//clear the angular cache as well -- added by bijay -- 18/10/2018
    this.router.navigate(['/authentication']);
  }

  loadOtherOffer(param) {
   // console.log(localStorage);
    localStorage.setItem('starterID',param.starterid);
      var authenticateLocalStorage = JSON.parse(localStorage.getItem('authentication'));
     // console.log('after');
      authenticateLocalStorage.starterID = param.starterid;
      authenticateLocalStorage.starterJobTitle = param.jobtitle;
      localStorage.setItem('authentication',JSON.stringify(authenticateLocalStorage));
     // console.log(localStorage);
     // this.starterId = param.starterid;
     // var number = 1;
      //this.store.dispatch(new ServerLogoutAction({}));
      location.reload();
    //  this.store.dispatch(new GetStageInfoAction({}));
   //   console.log(param.starterid +'  ' + param.userid);
  }

  updateVersion() {
    this.store.dispatch(new ApplicationUpdateVersionAction({}));
  }

  checkVersion() {
    this.store.dispatch(new ApplicationCheckVersionAction({}));
  }

  getCountDown(num: number): string {
    return `You will be redirected to Login after ${num}  ${(num > 1) ? 'seconds' : 'second'}`;
  }

  private subscribeToNotifications() {
    this.subscriptions.push(
      this.store.select(fromRoot.getApplicationLatestNotification).subscribe(
        (toastr: IToastr) => {
          if (toastr) {
            if (!toastr.closeHtml) {
              this.toasterService.pop(toastr.type, toastr.title, toastr.body);
            } else {
              const interval = 1000;
              const timeout = 1000000;
              const seconds = timeout / 1000;
              let subscription: Subscription;

              const toastrWithClose = {
                type: toastr.type,
                title: toastr.title,
                body: this.getCountDown(seconds),
                bodyOutputType: BodyOutputType.TrustedHtml,
                showCloseButton: true,
                onHideCallback: toastr.hideCb,
                // clickHandler: toastr.hideCb,
                onShowCallback: (toastr) => {
                  console.log('Toast ' + toastr.toastId + ' has been added!');
                  // Run the timer with 1 second iterval
                  const observable = Observable.interval(interval).take(seconds);
                  // Start listen seconds beat
                  subscription = observable.subscribe((count: number) => {
                    // Update title of toast
                    toastr.body = this.getCountDown(seconds - count - 1);
                  });
                }
              };
              this.toasterService.pop(toastrWithClose);
            }
          }
        }
      )
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/application/containers/application/application.component.ts